
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/pamirsau-slaptazodi",
      function () {
        return require("private-next-pages/lt/pamirsau-slaptazodi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/pamirsau-slaptazodi"])
      });
    }
  